export const SPORTSBOOK_WIDGETS_IDS = {
  betslipWidget: 'betslipWidget',
  eSportLeftSideBarWidget: 'eSportLeftSideBarWidget',
  eSportMiddleWidget: 'eSportMiddleWidget',
  eSportSportsMenuWidget: 'eSportSportsMenuWidget',
  europeanLiveContentWidget: 'europeanLiveContentWidget',
  europeanPrematchLeftWidget: 'europeanPrematchLeftWidget',
  europeanPrematchMiddleWidget: 'europeanPrematchMiddleWidget',
  sportsbookGamesList: 'sportsbookGamesList',
  sportsbookGamesListMarkets: 'sportsbookGamesListMarkets',
  sportsbookSingleView: 'sportsbookSingleView',
  sportsbookLeftSideBarWidget: 'sportsbookLeftSideBarWidget',
  sportsbookSportsMenuWidget: 'sportsbookSportsMenuWidget',
  sportsbookTabsSwitcherWidget: 'sportsbookTabsSwitcherWidget',
  calendarWidget: 'calendarWidget',
  resultsWidget: 'resultsWidget',
  multiViewWidget: 'multiViewWidget',
  overViewWidget: 'overViewWidget',
  tournamentsWidget: 'tournamentsWidget',
  racingCategoryWidget: 'racingCategoryWidget',
  racingLeftSideWidget: 'racingLeftSideWidget',
  racingUpcomingRacesWidget: 'racingUpcomingRacesWidget'
};
